import { ReserveTicketsRequest } from './reserve-tickets-request';

export enum ItemType {
    SHOW = 'show',
    SUBSCRIPTION = 'subscription',
    PARKING = 'parking',
    COMBO = 'COMBO',
    BYOC = 'BYOC',
    MEMBER = 'MEMBER',
    GIFT_CERTTIFICATES='GIFT_CERTTIFICATES'
}

export interface HoldItemRequest extends ReserveTicketsRequest {
    type: ItemType |any;
    id: number;

}
